import { lazy } from 'react';
import { HiOutlineClipboardDocumentList, HiOutlineDocumentText, HiOutlineBuildingLibrary, HiOutlineUsers } from 'react-icons/hi2';
import type { ModuleManifest } from '../types';

const AdministrationLayout = lazy(() => import('./components/AdministrationLayout'));
const CaseManagementPage = lazy(() => import('./components/CaseManagementPage'));
const CaseDetailPage = lazy(() => import('./components/CaseDetailPage'));
const DocumentManagementPage = lazy(() => import('./components/DocumentManagementPage'));
const CouncilSupportPage = lazy(() => import('./components/CouncilSupportPage'));
const HRDashboardPage = lazy(() => import('./components/HRDashboardPage'));

export const adminManifest: ModuleManifest = {
  name: 'admin_mod',
  featureFlag: 'module_admin',
  label: 'Administration',
  icon: HiOutlineClipboardDocumentList,
  basePath: 'administration',
  navItems: [
    { key: 'adm-cases', label: 'Cases', icon: HiOutlineClipboardDocumentList, path: '/app/administration/cases', matchFn: (p) => p.startsWith('/app/administration/cases') },
    { key: 'adm-documents', label: 'Documents', icon: HiOutlineDocumentText, path: '/app/administration/documents', matchFn: (p) => p.startsWith('/app/administration/documents') },
    { key: 'adm-council', label: 'Council', icon: HiOutlineBuildingLibrary, path: '/app/administration/council', matchFn: (p) => p.startsWith('/app/administration/council') },
    { key: 'adm-hr', label: 'HR', icon: HiOutlineUsers, path: '/app/administration/hr', matchFn: (p) => p.startsWith('/app/administration/hr') },
  ],
  routes: [
    {
      path: 'administration',
      component: AdministrationLayout,
      children: [
        { path: 'cases', component: CaseManagementPage },
        { path: 'cases/:caseId', component: CaseDetailPage },
        { path: 'documents', component: DocumentManagementPage },
        { path: 'council', component: CouncilSupportPage },
        { path: 'hr', component: HRDashboardPage },
      ],
    },
  ],
};
